(ns practitest.frontend.landing.subs
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub
 :landing/account
 (fn [db _]
   (get-in db [:landing :account])))

(re-frame/reg-sub
 :landing/account-message
 (fn [db _]
   (get-in db [:landing :account-message])))

(re-frame/reg-sub
 :landing/display-account-message
 (fn [db _]
   (get-in db [:landing :display-account-message])))

(def ^:const projects-per-page 4)

(re-frame/reg-sub
 :landing/all-projects
 (fn [db _]
   (get-in db [:landing :all-projects] [])))

(re-frame/reg-sub
 :landing/projects
 :<- [:landing/all-projects]
 :<- [:landing/projects-page]
 (fn [[all-projects page] _]
   (let [start (* (dec page) projects-per-page)]
     (->> all-projects
          (drop start)
          (take projects-per-page)))))

(re-frame/reg-sub
 :landing/total-projects
 :<- [:landing/all-projects]
 (fn [all-projects _]
   (count all-projects)))

(re-frame/reg-sub
 :landing/projects-page
 (fn [db _]
   (get-in db [:landing :projects-page] 1)))

(re-frame/reg-sub
 :landing/assigned-items
 (fn [db _]
   (get-in db [:landing :assigned-items])))

(def ^:const histories-per-page 4)

(re-frame/reg-sub
 :landing/all-histories
 (fn [db _]
   (get-in db [:landing :all-histories] [])))

(re-frame/reg-sub
 :landing/histories
 :<- [:landing/all-histories]
 :<- [:landing/histories-page]
 (fn [[all-histories page] _]
   (let [start (* (dec page) histories-per-page)]
     (->> all-histories
          (drop start)
          (take histories-per-page)))))

(re-frame/reg-sub
 :landing/total-histories
 :<- [:landing/all-histories]
 (fn [all-histories _]
   (count all-histories)))

(re-frame/reg-sub
 :landing/histories-page
 (fn [db _]
   (get-in db [:landing :histories-page] 1)))

(re-frame/reg-sub
 :landing/whats-new
 (fn [db _]
   (get-in db [:landing :whats-new] [])))
